import { loadStripe } from '@stripe/stripe-js'

let stripePromise
export function useStripe() {
    if (!stripePromise) {
        stripePromise = loadStripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
    }

    return stripePromise
}
